<template>
    <div class="slack-wrapper">
        <img class="slide-image" src="@/assets/img/connect-slack.png" />
        <Spacer height="1.5rem" />
        <Text v-if="isDomainSpecificConnection" as="p" size="f-8">
            Send Slack alerts for <b>this account</b> to a specific channel. By default, Opteo sends
            all of your alerts to the channel specified in Account Settings. Account-level alerts
            help to prevent clutter and streamline your Slack alerts.
        </Text>
        <Text v-else as="p" size="f-8">
            Send alerts to your preferred Slack channel. By default, Opteo sends all alerts to the
            channel specified. To set up account-level alerts, open an account, click the
            <b>Settings</b> tab, and scroll to the <b>Connect Slack Channel</b> section.
        </Text>
        <Spacer height="1.5rem" />
        <SlackConnect :is-domain-specific-connection="isDomainSpecificConnection" />
    </div>
</template>

<script setup lang="ts">
import { Text, Spacer } from '@opteo/components-next'
import SlackConnect from '../connectors/SlackConnect.vue'

defineProps<{ isDomainSpecificConnection: boolean }>()
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
@import '@/assets/css/variables.scss';

.slack-wrapper {
    @include pa-32;
}
.slide-image {
    @include container;
}
</style>
